import View from './Page.jsx'
import container from './container.js'

const StocksList = container(View)
StocksList.displayName = 'StocksList'

export default StocksList
